import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './interiorDesign.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import topHeroImage from '../../assets/interior-top-hero.png';
import midPhoto from '../../assets/interior-mid-photo.png';
import { sendContactEmail } from '../../utils/emailjs';

const InteriorDesign = () => {
  const navigate = useNavigate();
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  const handleNavigateToInquiryForm = () => {
    navigate('/sell-your-business#kw-sell-inquiry');
  };

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Interior Design Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__interior-page">
      <section className="kw__interior-hero kw__interior-section">
        <p className="kw__interior-outline">Interior Design</p>
        <h1 className="kw__interior-title">Transforming Environments, Engineering High-Performance Spaces</h1>
        <p className="kw__interior-copy">
          A thoughtfully designed space does more than look exceptional it enhances productivity, shapes brand identity, and optimizes human
          interaction. We provide comprehensive, turnkey interior design and spatial architecture solutions for high-end corporate, commercial, and
          retail environments. By merging creative design principles with advanced material sourcing and rigorous project management, we transform raw
          concepts into functional, inspiring environments that perfectly embody our clients&apos; operational goals.
        </p>
      </section>

      <section className="kw__interior-top-image-wrap" aria-hidden="true">
        <img src={topHeroImage} alt="" className="kw__interior-top-image" />
      </section>

      <section className="kw__interior-dark-band">
        <div className="kw__interior-section kw__interior-dark-content">
          <h2>Project Complexity Managed - From Concept to Execution</h2>
          <p>
            We master the complex, high-pressure timelines of interior fit-outs and spatial renovations. Managing multi-disciplinary teams, material
            procurement logistics, structural compliance, and strict engineering tolerances requires precise corporate discipline. Our end-to-end
            management framework ensures zero construction lag, absolute adherence to budget parameters, and flawless material execution from initial
            layout to final handover.
          </p>
        </div>
      </section>

      <section className="kw__interior-scale-section kw__interior-section">
        <h2>Scaling Spatial Excellence Across Commercial Markets</h2>
        <p>
          Building a premier design portfolio relies on a deep understanding of structural flow, aesthetic longevity, and seamless vendor ecosystems.
          Our focus remains on expanding our design and execution footprint while maintaining uncompromising standards of quality assurance and
          corporate transparency. We ensure consistent project delivery, innovative spatial planning, and robust engineering reliability across diverse
          corporate and retail segments. This design platform is purpose-built for commercial developers, corporate enterprises, and brand partners who
          understand that physical scale only succeeds when meticulous operational management protects the spatial vision.
        </p>
      </section>

      <section className="kw__interior-mid-photo-wrap" aria-hidden="true">
        <img src={midPhoto} alt="" className="kw__interior-mid-photo" />
      </section>

      <section className="kw__interior-cta kw__interior-section">
        <h2>Ready to Redefine Your Corporate or Retail Space?</h2>
        <p>
          If you are looking to optimize your commercial workspace, execute a high-end turnkey retail rollout, or partner on upcoming interior design
          and fit-out projects partner with us and let&apos;s design the future together.
        </p>
        <button type="button" className="kw__interior-cta-btn" onClick={handleNavigateToInquiryForm}>
          <span>Let&apos;s Discuss Your Project</span>
          <img src={buttonArrow} alt="" />
        </button>
      </section>

      <section className="kw__interior-newsletter kw__interior-section">
        <div className="kw__interior-news-copy">
          <p className="kw__interior-news-label">Newsletter</p>
          <h3>Never Miss An Update</h3>
          <p>
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to your
            inbox.
          </p>
        </div>

        <form className="kw__interior-news-form" onSubmit={handleSubmit}>
          <div className="kw__interior-news-row">
            <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleChange} />
            <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleChange} />
          </div>
          <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleChange} />
          <button type="submit" className="kw__interior-news-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>
      </section>
    </div>
  );
};

export default InteriorDesign;
